/**
 * @desc 发送
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageWebSocket.send.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageWebSocket/send`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
